<div class="dashboard-layout dashboard-overview">
    <!-- Stats Section -->
    <nz-row [nzGutter]="[16, 16]">
        <nz-col [nzXs]="24" [nzMd]="24">
            <div class="summary-cards-section">
                <nz-row [nzGutter]="[16, 16]">
                    <nz-col [nzXs]="24" [nzSm]="6" *ngFor="let stat of stats">
                        <nz-card class="summary-card compact-stat-card" (click)="toStatRedirect(stat)">
                            <nz-statistic [nzTitle]="stat.label" [nzValue]="stat.value != null ? stat.value : '0'"
                                [nzValueStyle]="{ color: stat.valueColor || '#3f8600' }">
                            </nz-statistic>
                        </nz-card>
                    </nz-col>
                </nz-row>
            </div>
        </nz-col>
    </nz-row>

    <nz-row [nzGutter]="[16, 16]" style="margin-top: 10px;" *ngIf="outsourcingItems.length > 0">
        <nz-col [nzXs]="24" [nzSm]="6" *ngFor="let item of outsourcingItems">
            <nz-card class="summary-card compact-stat-card" (click)="toOutsourceRedirect(item)">
                <nz-statistic [nzTitle]="item.label" [nzValueTemplate]="valueTpl">
                    <ng-template #valueTpl>
                        <nz-tag [nzColor]="
                            item.status === 'Completed' ? 'success'
                            : item.status === 'In Progress' ? 'processing'
                            : item.status === 'Pending' ? 'warning'
                            : 'error'" nzMode="default">
                            {{ item.status }}
                        </nz-tag>
                    </ng-template>
                </nz-statistic>
            </nz-card>
        </nz-col>
    </nz-row>
</div>

<nz-divider class="dashboard-section-divider"></nz-divider>

<div class="dashboard-layout dashboard-overview">
    <!-- External Moderators Section -->
    <div style="margin-bottom: 16px;">
        <h3 style="margin: 0; font-weight: 600; font-size: 15px;">External Moderators</h3>
    </div>

    <nz-skeleton [nzActive]="true" [nzLoading]="moderatorsLoading" [nzParagraph]="{ rows: 2 }">
        <nz-empty *ngIf="moderators.length === 0" nzNotFoundContent="No moderators linked to this event"></nz-empty>
        <nz-row [nzGutter]="[16, 16]" *ngIf="moderators.length > 0">
            <nz-col [nzXs]="24" [nzSm]="8" *ngFor="let m of moderators">
                <nz-card class="moderator-card" [nzBodyStyle]="{'padding': '16px'}">
                    <div class="moderator-card-header">
                        <div class="moderator-profile">
                            <nz-avatar nzIcon="user" class="moderator-avatar"></nz-avatar>
                            <div class="moderator-profile-meta">
                                <strong class="moderator-name">
                                    {{ m.name }}
                                    <a *ngIf="m.linkedin_url" [href]="m.linkedin_url" target="_blank" rel="noopener noreferrer"
                                        nz-tooltip nzTooltipTitle="LinkedIn" style="margin-left: 6px;">
                                        <nz-icon nzType="linkedin"></nz-icon>
                                    </a>
                                </strong>
                                <span class="moderator-role" *ngIf="m.job_title">{{ m.job_title }}</span>
                                <span class="moderator-company" *ngIf="m.company">{{ m.company }}</span>
                            </div>
                        </div>
                    </div>
                    <nz-divider style="margin: 10px 0;"></nz-divider>
                    <div class="moderator-contact-list">
                        <span class="moderator-contact-item" *ngIf="m.email"><nz-icon nzType="mail"></nz-icon>&nbsp;{{ m.email }}</span>
                        <span class="moderator-contact-item" *ngIf="m.phone_number"><nz-icon nzType="phone"></nz-icon>&nbsp;{{ m.phone_number }}</span>
                    </div>
                </nz-card>
            </nz-col>
        </nz-row>
    </nz-skeleton>
</div>

<!-- Reusable Moderator Modal -->
<app-moderator-modal
    [(visible)]="moderatorModalVisible"
    [moderator]="editingModerator"
    [allModerators]="allModerators"
    [linkedModeratorIds]="linkedModeratorIds"
    [allowExistingSelect]="true"
    [saving]="moderatorSaving"
    (save)="onModeratorSave($event)"
    (cancel)="closeModeratorModal()">
</app-moderator-modal>
